module.exports = __webpack_public_path__ + "assets/measure_monthly_total.592d9faf.svg";